const app = angular.module('formApp', ['validation.match', 'ngMaterial', 'ngMessages', 'ngSanitize', "ui.router", "ui.router.state.events", 'ngAnimate'])
    .config(function ($mdThemingProvider) {
        const v4pPalette = $mdThemingProvider.extendPalette('indigo', {
            '200': '4d2b88',
            '500': '1b015a',
            '700': 'd32f2f',
            'A200': 'E60064',
            'A400': 'E60064',
            'A700': 'ad003a',
            'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                                // on this palette should be dark or light

            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'],
            'contrastLightColors': undefined    // could also specify this if default was 'dark'
        });
        $mdThemingProvider.definePalette('v4pPalette', v4pPalette);
        $mdThemingProvider.theme('default')
            .primaryPalette('v4pPalette')
            .accentPalette('v4pPalette')
        let baseUrl = window.location.hostname;
        if (baseUrl.indexOf("vets4pets.com") !== -1 || baseUrl.indexOf("-prod") !== -1) {
            //This means we are on prod server
            Parse.serverURL = 'https://app-prod.prod.v4papp.aws.petsathome.co.uk/parse/'
        } else if (baseUrl.indexOf("nonprod") !== -1) {
            Parse.serverURL = 'https://app-staging.nonprod.v4papp.aws.petsathome.co.uk/parse/'
        } else {
            Parse.serverURL = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/parse/';
        }
    })
    .config(['$locationProvider', function ($locationProvider) {
        $locationProvider.hashPrefix('');
    }])
    .config(["$compileProvider", function ($compileProvider) {
        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(local|http|https|app|tel|ftp|file|blob|content|ms-appx|x-wmapp0|cdvfile):|data:image\//);
    }])
    .config(function ($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            if (!date) {
                return null;
            }
            return moment((date.getMonth() + 1) + "/" + (date.getDate()) + "/" + date.getFullYear()).tz(moment.tz.guess()).format('DD/MM/YYYY');
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            const m = moment.utc(dateString, ['DD/MM/YYYY', 'D/M/YYYY'], true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    })
    .value('googleChartApiConfig', {
        version: '1.1',
        optionalSettings: {
            packages: ['corechart'],
            language: 'en'
        }
    });
app.directive('confirmPassword', ConfirmPassword);

function ConfirmPassword() {

    const linkFn = function (scope, element, attributes, ngModel) {
        ngModel.$validators.confirmPassword = function (modelValue) {
            return modelValue === scope.password;
        };

        scope.$watch("password", function () {
            ngModel.$validate();
        });
    };

    return {
        require: "ngModel",
        scope: {
            password: "=confirmPassword"
        },
        link: linkFn
    };
}

app.directive('backImg', function () {
    return function (scope, element, attrs) {
        attrs.$observe('backImg', function (value) {
            const subbedUrl = value.replace("http://", "https://s3.amazonaws.com/");
            element.css({
                //'background-image': 'linear-gradient(rgba(255, 255, 255, 0.5),rgba(255, 255,255, 0.5)), url(' + value + ')',
                'background-image': 'url(' + subbedUrl + ')',
                'background-size': 'cover',
                'background-position': 'center',
            });
        });
    };
});